import React, { useState, useRef, useEffect } from "react";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
// eslint-disable-next-line no-unused-vars
import { useParams, NavLink } from "react-router-dom";
import { PlusCircleTwoTone } from "@ant-design/icons";
import { ClientMenu } from "../../../components/AdminComponents/MenuItems";
import {
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Row,
  Col,
  Switch,
  Tag,
  Table,
} from "antd";
import "../formStyles.css";
import Axios from "../../../api/Axios";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { BackwardOutlined, SaveOutlined, DeleteOutlined, PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { PatternFormat } from "react-number-format";
import { message } from "antd";
import {
  capitalizeWords,
  ClientTypeDropDown,
} from "../../../components/icons/ApplicationColor";
import { getRoleTrue } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import dayjs from "dayjs";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
const { RangePicker } = DatePicker;
const { Option } = Select;

const ClientProjects = () => {
  const history = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [isUserExists, setIsUserExists] = useState(false);
  const [isUserIDExists, setIsUserIDExists] = useState(false);
  const [clientTypeOptions, setClientTypeOptions] = useState([]);
  const [nteeCode, setNteeCode] = useState([]);
  const [nteeCoreCode, setNteeCoreCode] = useState([]);
  // const [naicsres,setNaicsRes]=useState()
  const [showNtee, setShowNtee] = useState(false);
  const [showContract, setShowContract] = useState(true);
  const [insurerNameOpen, setInsurerNameOpen] = useState(false);
  const [insurerIdOpen, setInsurerIdOpen] = useState(false);
  const [purposeTypes, setPurposeTypes] = useState([]);
  const [accountExe, setAccountExe] = useState([]);
  const [accountTypeOptions, setAccountTypeOptions] = useState([]);
  const [brokerLabel, setBrokerLabel] = useState("Client");
  const [insurerList, setInsurerList] = useState([]);

  const [messageApi, contextHolder] = message.useMessage();
  const formRef = useRef();
  const userInfo = useSelector((state) => state.user);
  const [selectedCountry, setSelectedCountry] = useState("United States");
  const [selectedState, setSelectedState] = useState("");
  const [formValues, setFormValues] = useState({});
  const handleReset = () => {
    formRef.current.resetFields();
    setShowNtee(false);
  };

  //console.log(formRef.username);
  useEffect(() => {
    const clientTypeDropDown = async () => {
      const res = await Axios.get("options/org_type/");
      //console.log(res.data);
      setClientTypeOptions(res.data.org_type);
    };
    clientTypeDropDown();
  }, []);
  useEffect(() => {
    const NteeCode = async () => {
      const res = await Axios.get("/nteecode/");
      //console.log(res.data, "NteeCode");
      setNteeCode(res.data);
    };
    NteeCode();
  }, []);
  const NteeCoreCode = async (code) => {
    const res = await Axios.get(`/nteecorecode/?search=${code}`);
    //console.log(res.data, "NteeCoreCode");
    setNteeCoreCode(res.data);
  };
  useEffect(() => {
    const purposeTypesDropDown = async () => {
      const res = await Axios.get("options/purpose/");
      //console.log(res.data);
      setPurposeTypes(res.data.purpose);
    };
    purposeTypesDropDown();
  }, []);
  useEffect(() => {
    const accountExeDropDown = async () => {
      const res = await Axios.get("userlist/?role=account_executive");
      //console.log(res.data);
      setAccountExe(res.data);
    };
    accountExeDropDown();
  }, []);
  useEffect(() => {
    const fetchAccountTypes = async () => {
      if (formValues?.is_parent && accountTypeOptions.length === 0) {
        try {
          const res = await Axios.get("options/account_type/");
          setAccountTypeOptions(res.data.account_type);
        } catch (err) {
          console.error("Failed to fetch account types:", err);
        }
      }
    };
    fetchAccountTypes();
  }, [formValues?.is_parent, accountTypeOptions.length]);

  const fetchInsurers = async () => {
    if (formValues?.account_type) {
      try {
        const res = await Axios.get(
          `insurerlist/?page=1&page_size=100&account_type=${formValues.account_type}`
        );
        setInsurerList(res.data.results || []);
        if (res.data.broker_name) {
          setBrokerLabel(res.data.broker_name);
        } else {
          setBrokerLabel("Client");
        }
      } catch (err) {
        console.error("Failed to fetch insurers:", err);
      }
    } else {
      setInsurerList([]);
      setBrokerLabel("Client");
    }
  };

  useEffect(() => {
    fetchInsurers();
  }, [formValues?.account_type]);

  useEffect(() => {
    if (insurerNameOpen || insurerIdOpen) {
      fetchInsurers();
    }
  }, [insurerNameOpen, insurerIdOpen]);

  const handleInsurerNameChange = (index, value) => {
    const selectedInsurer = insurerList.find((item) => item.insurer_name === value);
    const currentRelationships = formRef.current.getFieldValue("account_relationships") || [];
    const newRelationships = [...currentRelationships];
    newRelationships[index] = {
      ...newRelationships[index],
      insurer_name: value,
      insurer_id: selectedInsurer ? selectedInsurer.insurer_id : undefined,
    };
    formRef.current.setFieldsValue({ account_relationships: newRelationships });
  };

  const handleInsurerIdChange = (index, value) => {
    const selectedInsurer = insurerList.find((item) => item.insurer_id === value);
    const currentRelationships = formRef.current.getFieldValue("account_relationships") || [];
    const newRelationships = [...currentRelationships];
    newRelationships[index] = {
      ...newRelationships[index],
      insurer_name: selectedInsurer ? selectedInsurer.insurer_name : undefined,
      insurer_id: value,
    };
    formRef.current.setFieldsValue({ account_relationships: newRelationships });
  };

  const handleClientTypeChange = (value) => {
    //console.log(`Selected client type: ${value}`);
    if (value === "non-profit") {
      setShowNtee(true);
    } else {
      setShowNtee(false);
    }
  };
  const handleRelationShipTypeChange = (value) => {
    if (value === "Prospect") {
      setShowContract(false);
    } else {
      setShowContract(true);
    }
  };
  const handleNteeCode = (value, option) => {
    const selectedNteeCode = option?.["data-ntee-code"];
    //console.log("Selected NTEE Code:", selectedNteeCode);
    if (selectedNteeCode) {
      formRef.current.setFieldsValue({
        ntee_core_code: null,
      });
    }
    NteeCoreCode(selectedNteeCode);
  };
  // eslint-disable-next-line no-unused-vars

  const handleFormChange = async (changedValues, allValues) => {
    if ("name" in changedValues && allValues.name.length > 3) {
      const response = await Axios.get(`/orgcheck/?search=${allValues.name}`);
      //console.log(response);
      setIsUserExists(response.data.exists);
    }
    if ("client_id" in changedValues && allValues.client_id.length > 3) {
      const response = await Axios.get(
        `/orgcheck/?search=${allValues.client_id}`
      );
      //console.log(response);
      setIsUserIDExists(response.data.exists);
    }
    // if ("naics_primary" in changedValues && allValues.naics_primary.length > 3) {
    //   const response = await Axios.get(
    //     `/naicslist/?search=${allValues.naics_primary}`
    //   );
    //   console.log(response);
    //   setNaicsRes(response.data);
    // }
  };

  const checkUserExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists().then(resolve, reject);
        }, 100);
      } else if (isUserExists) {
        reject("Client already exists");
      } else {
        resolve();
      }
    });
  };
  const checkUserIDExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserIDExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserIDExists().then(resolve, reject);
        }, 100);
      } else if (isUserIDExists) {
        reject("Client ID already exists");
      } else {
        resolve();
      }
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);

  const onFinish = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );

    // Remove the 'dateRange' field from the normalizedValues object
    delete normalizedValues.dateRange;

    // Retrieve the selected dates from the 'dateRange' field
    const selectedDates = values.dateRange;
    //console.log(selectedDates, "selectedDates");
    if (selectedDates && selectedDates.length > 0) {
      const contract_start_date = selectedDates[0].format("YYYY-MM-DD");
      normalizedValues.contract_start_date = contract_start_date;
      if (selectedDates.length === 2 && selectedDates[1] !== null) {
        const contract_end_date = selectedDates[1].format("YYYY-MM-DD");
        normalizedValues.contract_end_date = contract_end_date;
      }
    }

    const naics = normalizedValues.naics_primary?.split("-")[0]?.trim();
    normalizedValues.naics = naics;
    normalizedValues.country = selectedCountry;
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10);
    normalizedValues.created_date = formattedDate;

    //console.log("Received values of form: ", normalizedValues);

    try {
      normalizedValues.is_parent = values.is_parent || false;
      normalizedValues.classification =
        values.is_parent ? values.classification : "";
      normalizedValues.account_type =
        values.is_parent ? values.account_type : "";
      normalizedValues.broker_name =
        values.is_parent ? values.broker_name : "";

      if (values.is_parent && values.account_relationships) {
        const selectedInsurerOrgIds = values.account_relationships
          .map((rel) => {
            const insurer = insurerList.find(
              (item) => item.insurer_name === rel.insurer_name
            );
            return insurer ? insurer.org_insurer_id : null;
          })
          .filter((id) => id !== null);
        normalizedValues.org_insurer_id = selectedInsurerOrgIds;
      } else {
        normalizedValues.org_insurer_id = [];
      }

      const res = await Axios.post("/organizationcreate/", normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res.data.id, "RESPONSE AFTER NEW CLIENT CREATION");
      CreateSuccessfull(res.data.id);
    } catch (err) {
      //console.log(err);
      CreateFailed();
    }
  };

  const CreateSuccessfull = (id) => {
    messageApi.open({
      type: "success",
      content: "Client Details have been created.",
      duration: 5,
    });
    setTimeout(() => {
      history(`/admin-manager/clients/profile/${id}`);
    }, 4000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Client Details have not been Created.",
      duration: 5,
    });
  };
  //
  const [naicsRes, setNaicsRes] = useState([]);
  const [selectedNaics, setSelectedNaics] = useState("");

  const handleNaicsSearch = async (value) => {
    //console.log(value);
    if (value.length >= 2) {
      const response = await Axios.get(`/naicslist/?search=${value}`);
      //console.log(response);
      setNaicsRes(response.data);
    } else {
      setNaicsRes([]);
    }
  };

  const handleNaicsSelect = (value) => {
    setSelectedNaics(value);
  };

  const handleNaicsBlur = () => {
    if (!selectedNaics) {
      setSelectedNaics("");
    }
  };
  const [defaultStartDate, setDefaultStartDate] = useState(dayjs());

  useEffect(() => {
    // Set default start date to today
    setDefaultStartDate(dayjs());
  }, []);
  const thirdMenuData = [
    {
      path: `/admin-manager/clients/add-user`,
      name: "ADD Client",
      icon: (
        <PlusCircleTwoTone
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];
  const tagRender = (props) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 3,
        }}
      >
        {label && label.length > 9 ? `${label.slice(0, 9)}...` : label}
      </Tag>
    );
  };

  return (
    <Sidebar props={ClientMenu} style={{ overFlowX: "hidden !important" }}>
      {contextHolder}
      <SecondaryNav menuItems={thirdMenuData} />
      <div className="form-container-2">
        <Form
          name="complex-form"
          onFinish={onFinish}
          onValuesChange={(changedValues, allValues) => {
            handleFormChange(changedValues, allValues);
            setFormValues(allValues);
          }}
          layout="vertical"
          ref={formRef}
          initialValues={{
            dateRange: [defaultStartDate, null],
          }}
          labelCol={{
            span: 25,
          }}
          wrapperCol={{
            span: 80,
          }}
          style={{
            Width: "100%",
          }}
        >
          <div className="one">
            <div className="Child1">
              <div className="group1">
                <div className="form-heading">
                  {capitalizeWords("ADD NEW CLIENT")}
                </div>
                <div className="antd-test" style={{ marginTop: "2rem" }}>
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                      <Form.Item
                        label={<p className="my-form-lables">Client Name</p>}
                        validateFirst={true}
                      >
                        <Form.Item
                          validateFirst={true}
                          name="name"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "Username is required",
                            },

                            {
                              validator: checkUserExists,
                              validateTrigger: "onChange",
                            },
                          ]}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder={"Enter client name"}
                            // disabled
                            autoComplete="off"
                            style={{
                              opacity: 1,
                              color: "black",
                            }}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Client ID</p>}
                        validateFirst={true}
                      >
                        <Form.Item
                          validateFirst={true}
                          name="client_id"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "Client ID is required",
                            },
                            {
                              max: 20,
                              message: "Must be less than 20 characters ",
                            },
                            {
                              validator: checkUserIDExists,
                              validateTrigger: "onChange",
                            },
                          ]}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder="Enter Client ID"
                            // style={{}}
                            // disabled
                            style={{
                              opacity: 1,
                              color: "black",
                            }}
                            autoComplete="off"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Client Type</p>}
                        rules={[
                          {
                            required: true,
                            message: "client type is required",
                          },
                        ]}
                      >
                        <Input.Group compact>
                          <Form.Item name="org_type" noStyle>
                            <Select
                              placeholder="Select Type"
                              className="my-form-input-antd-test"
                              onChange={handleClientTypeChange}
                            >
                              <Option value="">None</Option>
                              {clientTypeOptions?.map((option) => (
                                <Option key={option} value={option}>
                                  {option === "govern" ? "government" : option}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={5} lg={4} xl={4}>
                      <Form.Item
                        label={<p className="my-form-lables">EIN/Tax ID</p>}
                      >
                        <Form.Item
                          name="ein"
                          noStyle
                          rules={[
                            {
                              pattern: /^\d{2}-\d{7}$/,
                              message: "format req xx-xxxxxxx",
                            },
                          ]}
                        >
                          <PatternFormat
                            format="##-#######"
                            className="my-form-input-antd-test"
                            style={{
                              paddingTop: "0.4rem",
                              paddingBottom: "0.4rem",
                              paddingLeft: "0.4rem",
                              border: "0.15rem solid black",
                            }}
                            placeholder={" xx-xxxxxxx"}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
                <div className="antd-test">
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                      <Form.Item
                        label={<p className="my-form-lables">Address</p>}
                      >
                        <Form.Item name="address" noStyle>
                          <Input
                            className="my-form-input-antd-test"
                            placeholder="Enter client's address"
                          />
                        </Form.Item>
                      </Form.Item>
                      {/* <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter client's address"
                    /> */}
                    </Col>
                    <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Country</p>}
                      >
                        <Input.Group compact>
                          <Form.Item name="country" noStyle>
                            <CountryDropdown
                              value={selectedCountry}
                              onChange={(val) => setSelectedCountry(val)}
                              className="my-form-input-antd-test"
                              defaultOptionLabel="United States"
                              style={{ height: "3.3rem" }}
                            />
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={5} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">State</p>}
                      >
                        <Input.Group compact>
                          <Form.Item name="state" noStyle>
                            <RegionDropdown
                              country={selectedCountry}
                              value={selectedState}
                              onChange={(val) => setSelectedState(val)}
                              className="my-form-input-antd-test"
                              style={{ height: "3.3rem" }}
                            />
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={4} xl={4}>
                      <Form.Item label={<p className="my-form-lables">City</p>}>
                        <Form.Item name="city" noStyle>
                          <Input
                            className="my-form-input-antd-test"
                            placeholder="Enter City"
                          />
                        </Form.Item>
                      </Form.Item>
                      {/* <Input
                      className="my-form-input-antd-test"
                      placeholder="Enter client's address"
                    /> */}
                    </Col>
                  </Row>
                </div>
                <div className="antd-test">
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={5} lg={4} xl={4}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">ZIP/Postal Code</p>
                        }
                      >
                        <Form.Item
                          name="zipcode"
                          noStyle
                          rules={[
                            {
                              pattern:
                                selectedCountry === "United Kingdom"
                                  ? /^[0-9a-zA-Z]*$/
                                  : /^[0-9]*$/,
                              message:
                                selectedCountry === "United Kingdom"
                                  ? "Please enter valid characters only"
                                  : "Please enter numbers only",
                            },
                            {
                              min:
                                selectedCountry === "United States" ||
                                  selectedCountry === "India" ||
                                  selectedCountry === "United Kingdom" ||
                                  selectedCountry === ""
                                  ? 5
                                  : undefined,
                              max:
                                selectedCountry === ""
                                  ? 5
                                  : selectedCountry === "United States"
                                    ? 5
                                    : selectedCountry === "India"
                                      ? 6
                                      : selectedCountry === "United Kingdom"
                                        ? 7
                                        : undefined,
                              message: "Invalid postal code",
                            },
                          ]}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder="zip code"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={10} md={5} lg={4} xl={4}>
                      <Form.Item
                        label={<p className="my-form-lables">Sub Account</p>}
                        name="is_parent"
                        valuePropName="checked"
                      >
                        <Switch
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                          onChange={(checked) => {
                            if (!checked) {
                              formRef.current.setFieldsValue({
                                classification: "",
                                account_type: undefined,
                                broker_name: "",
                                account_relationships: [],
                              });
                            } else {
                              const current = formRef.current.getFieldValue("account_relationships");
                              if (!current || current.length === 0) {
                                formRef.current.setFieldsValue({
                                  account_relationships: [{ insurer_name: undefined, insurer_id: undefined }]
                                });
                              }
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    {formValues?.is_parent && (
                      <>
                        <Col xs={24} sm={12} md={6} lg={7} xl={7}>
                          <Form.Item
                            label={
                              <p className="my-form-lables">Customer Name</p>
                            }
                            name="classification"
                            required={false}
                            rules={[
                              {
                                required: true,
                                message: "Customer Name is required",
                              },
                            ]}
                          >
                            <Input
                              className="my-form-input-antd-test"
                              placeholder="Enter customer name"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                          <Form.Item
                            label={
                              <p className="my-form-lables">Account Type</p>
                            }
                            name="account_type"
                          >
                            <Select
                              className="my-form-input-antd-test insurer-select-readonly"
                              placeholder="Select Account Type"
                              allowClear
                              style={{
                                color: "black",
                                opacity: 1,
                              }}
                              onChange={() => {
                                formRef.current.setFieldsValue({
                                  broker_name: "",
                                  account_relationships: [{ insurer_name: undefined, insurer_id: undefined }]
                                });
                              }}
                            >
                              {accountTypeOptions?.map((option) => (
                                <Option key={option} value={option}>
                                  {option}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        {formValues?.account_type && (
                          <>
                            <Col xs={24} sm={12} md={6} lg={7} xl={7}>
                              <Form.Item
                                label={
                                  <p className="my-form-lables">Serviced By</p>
                                }
                                name="broker_name"
                                required={false}
                                rules={[
                                  ({ getFieldValue }) => ({
                                    required:
                                      getFieldValue("account_type") ===
                                      "Broker" ||
                                      getFieldValue("account_type") ===
                                      "Consolidator",
                                    message: "Serviced By is required",
                                  }),
                                ]}
                              >
                                <Input
                                  className="my-form-input-antd-test"
                                  placeholder="Enter Serviced By name"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.List
                                name="account_relationships"
                                initialValue={[{ insurer_name: undefined, insurer_id: undefined }]}
                              >
                                {(fields, { add, remove }) => {
                                  const currentValues = formRef.current?.getFieldValue("account_relationships") || [];
                                  const selectedNames = currentValues.map(v => v?.insurer_name).filter(Boolean);
                                  const selectedIds = currentValues.map(v => v?.insurer_id).filter(Boolean);

                                  return (
                                    <>
                                      {fields.map(({ key, name, ...restField }, index) => (
                                        <Row gutter={20} key={key} align="top" style={{ width: '100%' }}>
                                          <Col xs={24} sm={12} md={6} lg={7} xl={7}>
                                            <Form.Item
                                              {...restField}
                                              label={
                                                index === 0 ? (
                                                  <p className="my-form-lables">
                                                    {brokerLabel} Name
                                                  </p>
                                                ) : (
                                                  ""
                                                )
                                              }
                                              name={[name, "insurer_name"]}
                                            >
                                              <Select
                                                allowClear
                                                className="my-form-input-antd-test"
                                                placeholder={`Select ${brokerLabel.toLowerCase()} name`}
                                                onDropdownVisibleChange={(open) => setInsurerNameOpen(open)}
                                                onChange={(val) =>
                                                  handleInsurerNameChange(index, val)
                                                }
                                              >
                                                {insurerList?.map((item) => (
                                                  <Option
                                                    key={item.org_insurer_id}
                                                    value={item.insurer_name}
                                                    disabled={selectedNames.includes(item.insurer_name) && currentValues[index]?.insurer_name !== item.insurer_name}
                                                  >
                                                    {item.insurer_name}
                                                  </Option>
                                                ))}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} sm={12} md={6} lg={7} xl={7}>
                                            <Form.Item
                                              {...restField}
                                              label={
                                                index === 0 ? (
                                                  <p className="my-form-lables">
                                                    {brokerLabel} ID
                                                  </p>
                                                ) : (
                                                  ""
                                                )
                                              }
                                              name={[name, "insurer_id"]}
                                            >
                                              <Select
                                                allowClear
                                                className="my-form-input-antd-test"
                                                placeholder={`Select ${brokerLabel.toLowerCase()} ID`}
                                                onDropdownVisibleChange={(open) => setInsurerIdOpen(open)}
                                                onChange={(val) =>
                                                  handleInsurerIdChange(index, val)
                                                }
                                              >
                                                {insurerList?.map((item) => (
                                                  <Option
                                                    key={item.org_insurer_id}
                                                    value={item.insurer_id}
                                                    disabled={selectedIds.includes(item.insurer_id) && currentValues[index]?.insurer_id !== item.insurer_id}
                                                  >
                                                    {item.insurer_id}
                                                  </Option>
                                                ))}
                                              </Select>
                                            </Form.Item>
                                          </Col>
                                          <Col xs={24} sm={12} md={2} lg={2} xl={2}>
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "10px",
                                                marginTop:
                                                  index === 0 ? "38px" : "6px",
                                              }}
                                            >
                                              <PlusCircleOutlined
                                                onClick={() => {
                                                  const currentInsurers = formRef.current.getFieldValue("account_relationships") || [];
                                                  if (currentInsurers.length > 0) {
                                                    const lastInsurer = currentInsurers[currentInsurers.length - 1];
                                                    if (!lastInsurer?.insurer_name || !lastInsurer?.insurer_id) {
                                                      messageApi.warning(`Please select both ${brokerLabel.toLowerCase()} name and ID before adding another.`);
                                                      return;
                                                    }
                                                  }
                                                  add();
                                                }}
                                                style={{
                                                  color: "#1890ff",
                                                  fontSize: "20px",
                                                  cursor: "pointer",
                                                }}
                                              />
                                              {fields.length > 1 && (
                                                <MinusCircleOutlined
                                                  onClick={() => remove(name)}
                                                  style={{
                                                    color: "red",
                                                    fontSize: "20px",
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </Col>
                                        </Row>
                                      ))}
                                    </>
                                  );
                                }}
                              </Form.List>
                            </Col>
                          </>
                        )}
                      </>
                    )}
                    {showNtee && (
                      <>
                        <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                          <Form.Item
                            name="ntee_code"
                            label={
                              <p className="my-form-lables">NTEE Category</p>
                            }
                          >
                            <Select
                              showSearch
                              placeholder="Select Ntee category"
                              className="my-form-input-antd-test"
                              onChange={(value, option) =>
                                handleNteeCode(value, option)
                              }
                              filterOption={(inputValue, option) =>
                                option.children
                                  .join("")
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase())
                              }
                            >
                              {nteeCode?.map((option) => (
                                <Option
                                  key={option.id}
                                  value={option.id}
                                  data-ntee-code={option.ntee_code}
                                >
                                  <strong>{option?.ntee_code}</strong> :{" "}
                                  {option?.description}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                          <Form.Item
                            name="ntee_core_code"
                            label={
                              <p className="my-form-lables">NTEE Core Code</p>
                            }
                          >
                            <Select
                              showSearch
                              placeholder="Select Ntee Core Code"
                              className="my-form-input-antd-test"
                              filterOption={(inputValue, option) =>
                                option.children
                                  .join("")
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase())
                              }
                            >
                              {nteeCoreCode?.map((option) => (
                                <Option key={option.id} value={option.id}>
                                  <strong>{option?.ntee_core_code}</strong> :{" "}
                                  {option?.description}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                          <Form.Item
                            name="tax_type"
                            label={<p className="my-form-lables">Tax Type</p>}
                          >
                            <Select
                              placeholder="Select Tax Type"
                              className="my-form-input-antd-test"
                            >
                              <Option value="">None</Option>
                              <Option value="501-c-3">501(c)(3)</Option>
                              <Option value="501-c-4">501(c)(4)</Option>
                              <Option value="501-c-5">501(c)(5)</Option>
                              <Option value="501-c-6">501(c)(6)</Option>
                              <Option value="501-c-7">501(c)(7)</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </Row>
                </div>
              </div>

              <div className="group1" style={{ paddingTop: "0rem" }}>
                <div className="form-heading">
                  {capitalizeWords("ORGANIZATION PROFILE")}
                </div>
                <div className="antd-test" style={{ marginTop: "2rem" }}>
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={8} lg={9} xl={9}>
                      <Form.Item
                        label={<p className="my-form-lables">NAICS Code</p>}
                      >
                        <Form.Item name="naics_primary" noStyle>
                          <Select
                            showSearch
                            placeholder="Enter NAICS Code"
                            filterOption={false}
                            className="my-form-input-antd-test"
                            onSearch={handleNaicsSearch}
                            onSelect={handleNaicsSelect}
                            onBlur={handleNaicsBlur}
                            value={selectedNaics}
                          >
                            {naicsRes.map((naics) => (
                              <Option key={naics.code} value={naics.title}>
                                {`${naics.title}`}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                      <Form.Item
                        label={<p className="my-form-lables">Purpose</p>}
                      >
                        <Input.Group compact>
                          <Form.Item name="purpose" noStyle>
                            <Select
                              placeholder="Purpose of the client"
                              className="my-form-input-antd-test"
                            >
                              <Option value="">None</Option>
                              {purposeTypes?.map((option) => (
                                <Option key={option} value={option}>
                                  {option}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                      <Form.Item
                        label={<p className="my-form-lables">Fiscal end </p>}
                      >
                        <Input.Group compact>
                          <Form.Item name="fiscal_end" noStyle>
                            <Select
                              className="my-form-input-antd-test"
                              placeholder="Select Fiscal End"
                            >
                              <Option value={1}>January</Option>
                              <Option value={2}>February</Option>
                              <Option value={3}>March</Option>
                              <Option value={4}>April</Option>
                              <Option value={5}>May</Option>
                              <Option value={6}>June</Option>
                              <Option value={7}>July</Option>
                              <Option value={8}>August</Option>
                              <Option value={9}>September</Option>
                              <Option value={10}>October</Option>
                              <Option value={11}>November</Option>
                              <Option value={12}>December</Option>
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
                <div className="antd-test">
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Organization Type</p>
                        }
                      >
                        <Form.Item name="client_type" noStyle>
                          <Select
                            className="my-form-input-antd-test"
                            placeholder="Select Org Type"
                          >
                            <Option value={null}>None</Option>
                            {ClientTypeDropDown?.map((option) => (
                              <Option key={option} value={option}>
                                {option}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                      <Form.Item
                        label={<p className="my-form-lables">Industry</p>}
                      >
                        <Form.Item
                          name="industry"
                          noStyle
                          rules={[
                            ({ getFieldValue }) => ({
                              required: !!getFieldValue("naics_primary"),
                              message:
                                "Industry is required when NAICS Code is selected",
                            }),
                            {
                              pattern: /^[A-Za-z\s]*$/,
                              message: "Please enter valid words only",
                            },
                            {
                              min: 3,
                              message: "Minimum 3 characters required",
                            },
                          ]}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder="Enter Client's Industry"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={7} xl={7}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Partner Enabled</p>
                        }
                      >
                        <Form.Item
                          noStyle
                          name="partner_enabled"
                          valuePropName="checked"
                        >
                          <Switch
                            checkedChildren=" YES "
                            unCheckedChildren=" NO "
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>

                <div className="group-1-box" style={{ paddingTop: "0rem" }}>
                  <div
                    style={{
                      display: "inline-block",
                      marginTop: "2px",
                    }}
                  >
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="text"
                        htmlType="button"
                        style={{
                          background: "#D3D3D3",
                        }}
                        onClick={() => {
                          history("/admin-manager/clients");
                        }}
                      >
                        <BackwardOutlined />
                        Back
                      </Button>
                    </Form.Item>
                  </div>

                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="primary"
                        htmlType="button"
                        onClick={handleReset}
                      >
                        Reset
                      </Button>
                    </Form.Item>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        // className="my-form-input-end"
                        style={{
                          background: "#f58029",
                          fontWeight: "600",
                        }}
                        className="save-update-btn"
                      >
                        Save
                        <SaveOutlined />
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </div>
            <div className="Child2">
              <div className="group1">
                <div
                  className="form-heading"
                  style={{ paddingLeft: "0rem", paddingTop: "2rem" }}
                >
                  {capitalizeWords("RELATIONSHIP STATUS")}
                </div>
                <div className="antd-test" style={{ marginTop: "2rem" }}>
                  <Row gutter={20}>
                    <Col xs={21} sm={21} md={21} lg={21} xl={21}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Account Executive</p>
                        }
                      >
                        <Form.Item
                          name="account_executive"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "Account executive is required",
                            },
                          ]}
                          initialValue={
                            getRoleTrue(userInfo, 0, 0, "account_executive")
                              ? userInfo?.data?.id
                              : null
                          }
                        >
                          <Select
                            showSearch
                            placeholder="Select Client's Account Executive"
                            className="my-form-input-antd-test"
                            filterOption={(inputValue, option) =>
                              option.children
                                .join("")
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                            disabled={getRoleTrue(
                              userInfo,
                              0,
                              0,
                              "account_executive"
                            )}
                          >
                            {accountExe?.map((option) => (
                              <Option key={option.id} value={option.id}>
                                {option?.first_name} {option?.last_name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
                <div className="antd-test">
                  <Row gutter={20}>
                    <Col xs={21} sm={8} md={8} lg={8} xl={8}>
                      <Form.Item
                        label={<p className="my-form-lables">Status </p>}
                      >
                        <Form.Item
                          name="status"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "Status is required",
                            },
                          ]}
                          initialValue={true}
                        >
                          <Select
                            className="my-form-input-antd-test"
                            placeholder="Select"
                            style={{ borderRadius: "0.5rem" }}
                          >
                            <Option value={true}>Active</Option>
                            <Option value={false}>Inactive</Option>
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={21} sm={14} md={13} lg={13} xl={13}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Relationship Type</p>
                        }
                      >
                        <Form.Item
                          name="relationship_type"
                          noStyle
                          rules={[
                            {
                              required: true,
                              message: "Relationship Type is required",
                            },
                          ]}
                        >
                          <Select
                            className="my-form-input-antd-test"
                            placeholder="Select Type"
                            style={{ borderRadius: "0.5rem" }}
                            onChange={handleRelationShipTypeChange}
                          >
                            <Option value={"Client"}>Client</Option>
                            <Option value={"Prospect"}>Prospect</Option>
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>

                <div className="antd-test">
                  <Row gutter={20}>
                    <Col xs={21} sm={21} md={21} lg={21} xl={21}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">
                            {showContract
                              ? " Contract Start Date & end Date"
                              : " Trial Start Date & end Date"}
                          </p>
                        }
                      >
                        <Form.Item name="dateRange">
                          <RangePicker
                            placeholder={["Start Date", "End Date"]}
                            name="dateRange"
                            className="my-form-input-antd-test"
                            allowClear={false}
                            format="MMM-DD-YYYY"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </div>

              {/* <div className="group1">
                <div
                  className="form-heading"
                  style={{ paddingLeft: "0rem", paddingTop: "0rem" }}
                >
                  PRODUCTS
                </div>
                <div
                  className="group-1-box"
                  style={{ paddingTop: "0rem", paddingLeft: "0rem" }}
                >
                  <div style={{ display: "inline-block", marginTop: "3rem" }}>
                    <Tag
                      color="blue"
                      style={{
                        minWidth: "15rem",
                        textAlign: "center",
                        maxWidth: "18rem",
                        minHeight: "3rem",
                      }}
                    >
                      <span
                        className="tag-container"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          lineHeight: "3rem",
                        }}
                      >
                        Trak Learning
                      </span>
                    </Tag>
                  </div>
                  <div style={{ display: "inline-block", marginTop: "3rem" }}>
                    <Tag
                      color="orange"
                      style={{
                        minWidth: "15rem",
                        textAlign: "center",
                        maxWidth: "18rem",
                        minHeight: "3rem",
                      }}
                    >
                      <span
                        className="tag-container"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          lineHeight: "3rem",
                        }}
                      >
                        Trak Coaching
                      </span>
                    </Tag>
                  </div>
                </div>
                <div
                  className="group-1-box"
                  style={{ paddingTop: "0rem", paddingLeft: "0rem" }}
                >
                  <div style={{ display: "inline-block" }}>
                    <Tag
                      color="purple"
                      style={{
                        minWidth: "15rem",
                        textAlign: "center",
                        maxWidth: "18rem",
                        minHeight: "3rem",
                      }}
                    >
                      <span
                        className="tag-container"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          lineHeight: "3rem",
                        }}
                      >
                        Delegate HR
                      </span>
                    </Tag>
                  </div>
                  <div style={{ display: "inline-block" }}>
                    <Tag
                      color="magenta"
                      style={{
                        minWidth: "15rem",
                        textAlign: "center",
                        maxWidth: "18rem",
                        minHeight: "3rem",
                      }}
                    >
                      <span
                        className="tag-container"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          lineHeight: "3rem",
                        }}
                      >
                        Compbldr
                      </span>
                    </Tag>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </Form>
        {/* <ContactsTable data={record} /> */}
      </div>
    </Sidebar>
  );
};

export default ClientProjects;
